import { isProduction } from '@/helpers/common';

export enum CustomerIOEvents {
  GAME_CLOSED = 'game_closed',
  PWA_OPENED = 'pwa_lu_opened',
}

export const getCustomerIOId = (playerId: number | string) =>
  `levelupcasino:${playerId}`;

// Synchronous on purpose: on pagehide a pending waitForCio promise would never send.
export const setCustomerIOOnline = (playerId: number, isOnline: boolean) => {
  if (!isProduction()) return;

  const cio = (
    window as Window & { _cio?: { identify?: (data: object) => void } }
  )._cio;
  if (typeof cio?.identify !== 'function') return;

  try {
    cio.identify({
      id: getCustomerIOId(playerId),
      is_online: isOnline,
      last_seen_at: Math.floor(Date.now() / 1000),
    });
  } catch {
    console.error('CustomerIO setCustomerIOOnline failed');
  }
};
